import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { PromotionValidation } from 'uplisting-frontend/validations';

export default class PromotionRedemptionRepositoryService extends BaseRepositoryService<
  ModelRegistry['promotion-redemption'],
  ModelRegistry['promotion-redemption'][]
> {
  recordName = 'promotion-redemption';
  implementMethods = ['query', 'unloadAll'];

  validation = PromotionValidation;

  public async fetchPromotionRedemptionById(
    id: string,
  ): Promise<ModelRegistry['promotion-redemption'][]> {
    const cache = this.getDataFromCache(id);

    if (cache) {
      return cache;
    }

    const redemptions = await this.query({
      promotion_id: id,
    });

    const data = redemptions.slice();

    this.cache[id] = data;

    return data;
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/promotion-redemption': PromotionRedemptionRepositoryService;
  }
}
